<template>
  <div>
    <!-- <header-slot>
      <template v-slot:content-right>
        <div class="mr-3">
          <b-button
            @click="dataType.status = true"
            v-t="'CREATE'"
            variant="outline-success"
          ></b-button>
        </div>
      </template>
    </header-slot> -->

    <!-- Tabs -->
    <b-nav card-header pills class="m-0 mt-1">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ $t(item.title) | capitalize }}
      </b-nav-item>
    </b-nav>

    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view ref="routerViewTab" :key="routeName" />
    </b-card>
    <!-- <ModalHomeworkStatus
      v-if="dataType.status"
      @hideModal="hideModalHS"
      :dataType="dataType"
      @refresh="$refs.routerViewTab.refreshTable"
    /> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import ModalHomeworkStatus from "@/views/settings/views/homework-status/components/modals/ModalHomeworkStatus.vue";
export default {
  //   components: { ModalHomeworkStatus },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    tabs() {
      return this.$route.matched[2].meta.tabs;
    },
    routeName() {
      return this.$route.name;
    },
  },
};
</script>
